import { useData } from '.';

export const useSubevents = () => {
  const { data } = useData();
  return data?.subevents || [];
};
